export { FragmentMap, TransformDocumentOptions, transformDocument } from "./transformDocument";
export { TypeGetter, createTypeGetter } from "./typeGetter";
export {
  mergeDefinitions,
  mergeSelectionSets,
} from "./utilities";
